import flightsSuppliers from './../flights-suppliers';
import suppliers from './../../supplier/suppliers';
import tripItemTypes from './../../trip/trip-item-types';

export default function FlightsService(
    timeFilter,
    timeService,
) {
    'ngInject';

    const EUROSTAR_BOOK_DAYS_ADVANCE = 120;
    const BOOK_MONTHS_ADVANCE = 11;

    return {
        getFlightSupplierLogo,
        getFlightSupplierLogoSmall,
        isLowCostAirline,
        isMultiSegmentFlight,
        isTwoSegmentFlight,
        decorateResponse,
        getMaxBookDate,
        isCurrentDay,
    };

    function getMaxBookDate(tripItemType) {
        return tripItemTypes.eurostar === tripItemType
            ? moment().add({days: EUROSTAR_BOOK_DAYS_ADVANCE})
            : moment().add({months: BOOK_MONTHS_ADVANCE});
    }

    function getFlightSupplierLogo(code) {
        return flightsSuppliers[code].logo
            || flightsSuppliers.unkwnown.logo;
    }

    function getFlightSupplierLogoSmall(code) {
        return flightsSuppliers[code].logoSmall
            || flightsSuppliers.unkwnown.logoSmall;
    }

    function decorateResponse(response) {
        attachAlternativesIfAny(response.data);
        convertTimeFormat(response.data);
        return response;
    }

    function attachAlternativesIfAny({Recommendations}) {
        _.each(Recommendations, (flight) => {
            let hasAlternatives = false;
            _.each(flight.FlightSegments, ({FlightGroups}) => {
                if (FlightGroups.length > 1) {
                    hasAlternatives = true;
                }
                _.each(FlightGroups, (group) => {
                    group.daysShift = getFlightGroupsDaysShift(group);
                });
            });
            flight.hasAlternatives = hasAlternatives;
        });
    }

    function convertTimeFormat(flights) {
        if (flights.Filters && flights.Filters.RecommendationSegmentsTimes) {

            //Change format of time according to regional settings
            _.each(flights.Filters.RecommendationSegmentsTimes, (segmentTimes) => {
                _.each(segmentTimes.ArrivalTimes, composeTimeValue);
                _.each(segmentTimes.DepartureTimes, composeTimeValue);
            });
        }

        function composeTimeValue(time) {
            const splitTimes = time.Key.split('-');
            time.Key = timeFilter(splitTimes[0]) + ' - ' + timeFilter(splitTimes[1]);
        }
    }

    function getFlightGroupsDaysShift(flightGroup) {
        const dDate = moment(flightGroup.Flights[0].DepartureDate, 'YYYY-MM-DD');
        const aDate = moment(flightGroup.Flights[flightGroup.Flights.length - 1].ArrivalDate, 'YYYY-MM-DD');
        let diff = aDate.diff(dDate, 'days');

        if (diff > 0) {
            diff = '+' + diff;
        } else if (diff < 0) {
            diff = '' + diff;
        }

        return diff;
    }

    function isLowCostAirline(flight) {
        return flight
            && flight.ServiceOption
            && flight.ServiceOption.Id !== suppliers.amadeus.serviceOptions.flights;
    }

    function isMultiSegmentFlight(flight) {
        return flight.FlightSegments.length > 2;
    }

    function isTwoSegmentFlight(flight) {
        return flight.FlightSegments.length === 2;
    }

    function isCurrentDay(date) {
        return timeService.getDateInUserRegionFormat(date).isSame(moment(), 'day');
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/flights/services/flights-service.js